var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _stateSubscription, _states, _subscriptions, _updates, _workflow;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet2(e, t) { var r = _classPrivateFieldGet(t, e); return _classApplyDescriptorGet(e, r); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _classPrivateFieldSet(e, t, r) { var s = _classPrivateFieldGet(t, e); return _classApplyDescriptorSet(e, s, r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorSet(e, t, l) { if (t.set) t.set.call(e, l);else { if (!t.writable) throw new TypeError("attempted to set read only private field"); t.value = l; } }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { filter, Subscription, Subject } from 'rxjs';
import Service, { inject as service } from '@ember/service';
import analytics from '@banking/ui/workflows/debit-card-activation/analytics';
import workflow, { Screen, ActionType, createState, toggleModalAction } from '@banking/ui/workflows/debit-card-activation';
import { set } from '@ember/object';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { createEmit, createSelect } from '@banking/ui/lib/workflow-ember/decorators';
import connect from '@banking/ui/lib/workflow-ember/connect';
const SERVICE_REGISTRY_KEY = 'debit-card-activation-modal';
let DebitCardActivationModalState = (_dec = service('bb-debit/card-management-service'), _class = (_stateSubscription = /*#__PURE__*/new WeakMap(), _states = /*#__PURE__*/new WeakMap(), _subscriptions = /*#__PURE__*/new WeakMap(), _updates = /*#__PURE__*/new WeakMap(), _workflow = /*#__PURE__*/new WeakMap(), class DebitCardActivationModalState extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateFieldInitSpec(this, _stateSubscription, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _states, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _subscriptions, {
      writable: true,
      value: new Subscription()
    });
    _classPrivateFieldInitSpec(this, _updates, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _workflow, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "state", createState());
    _defineProperty(this, "doneCallback", () => {});
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor3, this);
    _initializerDefineProperty(this, "currentUserData", _descriptor4, this);
    _initializerDefineProperty(this, "dataApi", _descriptor5, this);
    _initializerDefineProperty(this, "features", _descriptor6, this);
    _initializerDefineProperty(this, "cardManagementService", _descriptor7, this);
    _classPrivateFieldSet(this, _stateSubscription, _classPrivateFieldGet2(this, _states).subscribe({
      next: state => set(this, 'state', state),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet2(this, _updates).subscribe(updateLogger('Debit Card Activation Modal'));
    analytics(_classPrivateFieldGet2(this, _updates)).subscribe(params => this.dataApi.track(...params));
    this.reset();
  }
  willDestroy() {
    this.deinitialize();
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    super.willDestroy();
  }
  reset() {
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    _classPrivateFieldSet(this, _subscriptions, new Subscription());
    _classPrivateFieldSet(this, _workflow, workflow(createState(), this.context));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).states.subscribe({
      next: next => _classPrivateFieldGet2(this, _states).next(next),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.subscribe(next => _classPrivateFieldGet2(this, _updates).next(next)));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.pipe(filter(([[before, next], action]) => action.type === ActionType.ToggleModal && (
    // At the create pin screen, the card is activated. We consider activation the primary done action
    before.screen === Screen.SUCCESS || before.screen === Screen.CREATE_PIN) && next.screen === Screen.None)).subscribe(() => this.doneCallback()));
  }
  emit(action) {
    _classPrivateFieldGet2(this, _workflow).emit(action);
  }
  openModal(unitToken, cardToken, doneCallback = () => {}) {
    _classPrivateFieldGet2(this, _workflow).emit(toggleModalAction(true, unitToken, cardToken));
    this.doneCallback = doneCallback;
  }
  get states() {
    return _classPrivateFieldGet2(this, _states).asObservable();
  }

  // TODO(cvu): remove when FIXME in debit-card-activation-upsell service is done.
  get currentScreen() {
    return this.state.screen;
  }
  deinitialize() {
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    _classPrivateFieldGet2(this, _stateSubscription)?.unsubscribe();
  }
  get context() {
    return {
      bizbank: this.bizbankApi.client,
      intl: this.intl,
      sentry: this.sentry,
      cardManagementService: this.cardManagementService
    };
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "cardManagementService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DebitCardActivationModalState as default };
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);